import { Package } from '../../../apis/graphql/types';
import { AdFormatType } from './adFormat';

export const DEFAULT_AD_DURATION = '11s-30s';
export const AD_DURATIONS = ['1s-10s', '11s-30s', '31s-60s', '61s-90s'] as const;
export type AdDurationType = (typeof AD_DURATIONS)[number];

const ESPN_ONLY_DURATION: AdDurationType = '1s-10s';
const SPORTS_CORE_OFFERING_SYSTEM_NAMES = ['espn', 'SPORTS'];

export const AD_GALLERY_DURATION_LABEL: string = '0:05 - 1:30';
export const AD_DURATION_LABELS: Map<AdDurationType, string> = new Map([
  ['1s-10s', '0:05 - 0:10'],
  ['11s-30s', '0:11 - 0:30'],
  ['31s-60s', '0:31 - 1:00'],
  ['61s-90s', '1:01 - 1:30'],
]);
export const AD_DURATION_BOUNDS: Map<AdDurationType, [number, number]> = new Map([
  ['1s-10s', [5, 11]],
  ['11s-30s', [11, 31]],
  ['31s-60s', [31, 61]],
  ['61s-90s', [61, 91]],
]);

export const getTierForDuration = (duration: number | null): AdDurationType | null => {
  if (!duration) {
    return null;
  }
  for (const [tier, [lowerInclusive, upperExclusive]] of AD_DURATION_BOUNDS.entries()) {
    if (duration >= lowerInclusive && duration < upperExclusive) {
      return tier;
    }
  }
  return null;
};

export const isAllowedDuration = (selectedPackage: Package | null, adFormat: AdFormatType, value: string): boolean => {
  if (value === ESPN_ONLY_DURATION) {
    return (
      adFormat === 'STANDARD' &&
      SPORTS_CORE_OFFERING_SYSTEM_NAMES.includes(selectedPackage?.coreOffering?.systemName ?? '')
    );
  }
  return true;
};
